// extracted by mini-css-extract-plugin
export default {"container":"yD-z","dimension":"zD-z","dimensionLabels":"AD-z"};